import React, { useState, useEffect } from 'react';
import { Map, Marker, Overlay } from 'pigeon-maps';
import './mymap.css';
import '../pages/home.css';
import { MdMargin } from 'react-icons/md';


/*   UTILS IMPORT */
import { prettyStationName } from '../utils/prettyStationName';

// Marker-Daten für verschiedene Orte
const markers = [
  { 
      id: 1, 
      lat: 47.88, 
      lng: 13.35111111, 
      text: 'MONDSEE', 
      title: 'MONDSEE',  
      seehöhe: '857m', 
      links: [
        { /*data: '25C', */label: 'Wetter', url: '../wetter/mondsee' },
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/mondsee' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/mondsee' },
        { label: 'Baumumfang', url: '../baumumfang/mondsee' },
      ]
    },
    { 
      id: 2, 
      lat: 47.3333, 
      lng: 12.40444444, 
      text: 'JOCHBERG', 
      title: 'JOCHBERG', 
      seehöhe: '1050m', 
      links: [
        { label: 'Wetter', url: '../wetter/jochberg' },
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/jochberg' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/jochberg' },
        { label: 'Baumumfang', url: '../baumumfang/jochberg' },
      ]
    },
    { 
      id: 3, 
      lat: 47.0833, 
      lng: 16.0684, 
      text: 'FUERSTENFELD', 
      title: 'FÜRSTENFELD', 
      seehöhe: '305m', 
      links: [
        { label: 'Wetter', url: '../wetter/fuerstenfeld'},
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/fuerstenfeld' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/fuerstenfeld' },
      
      ]
    },
    { 
      id: 4, 
      lat: 47.05888889, 
      lng: 14.1141667, 
      text: 'MURAU', 
      title: 'MURAU', 
      seehöhe: '1540m', 
      links: [
        { label: 'Wetter', url: '../wetter/murau' },
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/murau' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/murau' },
        { label: 'Baumumfang', url: '../baumumfang/murau' },      
      ]
    },
    { 
      id: 5, 
      lat: 48.17685, 
      lng: 16.3093,  
      text: 'WIEN-SCHOENBRUNN', 
      title: 'WIEN SCHÖNBRUNN', 
      seehöhe: '245m', 
      links: [
        { label: 'Wetter', url: '../wetter/wien-schoenbrunn'},
      ]
    },
    { 
      id: 6, 
      lat: 48.10694444, 
      lng: 16.0772, 
      text: 'KLAUSEN-LEOPOLDSDORF', 
      title: 'KLAUSEN-LEOPOLDSDORF', 
      seehöhe: '510m', 
      links: [
        { label: 'Wetter', url: '../wetter/klausen-leopoldsdorf' },
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/klausen-leopoldsdorf' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/klausen-leopoldsdorf' },
        { label: 'Baumumfang', url: '../baumumfang/klausen-leopoldsdorf' },
      ]
    },
    { 
      id: 7, 
      lat: 48.391396, 
      lng: 16.700893, 
      text: 'MATZEN', 
      title: 'MATZEN',
      seehöhe: '165m', 
      links: [
        { label: 'Wetter', url: '../wetter/matzen' },
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/matzen' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/matzen' },
      ]
    },
    { 
      id: 8, 
      lat: 47.63333333, 
      lng: 15.65694444, 
      text: 'MUERZZUSCHLAG', 
      title: 'MÜRZZUSCHLAG',
      seehöhe: '715m', 
      links: [
        { label: 'Wetter', url: '../wetter/muerzzuschlag' },
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/muerzzuschlag' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/muerzzuschlag' },
        { label: 'Baumumfang', url: '../baumumfang/muerzzuschlag' },
      ]
    },
    { 
      id: 9, 
      lat: 48.6342, 
      lng: 15.4266, 
      text: 'NEUPOELLA', 
      title: 'NEUPÖLLA', 
      seehöhe: '498m', 
      links: [
        { label: 'Wetter', url: '../wetter/neupoella' },
      ]
    },
    { 
      id: 10, 
      lat: 47.48333333, 
      lng: 16.55027778, 
      text: 'UNTERPULLENDORF', 
      title: 'UNTERPULLENDORF', 
      seehöhe: '233m', 
      links: [
        { label: 'Wetter', url: '../wetter/unterpullendorf' },
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/unterpullendorf' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/unterpullendorf' },
        { label: 'Baumumfang', url: '../baumumfang/unterpullendorf' },
      ]
    },
    { 
      id: 11, 
      lat: 48.68039, 
      lng: 14.7401, 
      text: 'WEITRA',
      title: 'WEITRA',
      seehöhe: '900m', 
      links: [
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/weitra' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/weitra' },
      ]
    },
    { 
      id: 12, 
      lat: 47.7979247, 
      lng: 15.6038552, 
      text: 'GIPPEL', 
      titel: 'GIPPEL', 
      seehöhe: '1538m',
      links: [
        { label: 'Wetter', url: '../wetter/gippel' },
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/gippel' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/gippel' },
      ]
    },
    { 
      id: 13, 
      lat: 46.9557511 , 
      lng: 14.321348, 
      text: 'KOLLERHUBE', 
      titel: 'KOLLERHUBE', 
      seehöhe: '1048m',
      links: [
        { label: 'Wetter', url: '../wetter/kollerhube' },
        { label: 'Bodenfeuchte', url: '../bodenfeuchte/kollerhube' },
        { label: 'Bodentemperatur', url: '../bodentemperatur/kollerhube' },
      ]
    }
  
  // Weitere Marker für zusätzliche Orte können hier hinzugefügt werden.
];

const MyOrtMap = ({ ort }) => {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [activePopup, setActivePopup] = useState(null);

  // UseEffect, um Marker basierend auf dem Ort zu finden
  useEffect(() => {
    const marker = markers.find(marker => marker.text.toLowerCase() === ort.toLowerCase());
    setSelectedMarker(marker); // Setzt den Marker für den Ort
  }, [ort]); // Nur wenn sich der Ort ändert

  // Funktion zum Handhaben der Klicks auf den Marker und zum Öffnen/Schließen des Popups
  const handleMarkerClick = (id) => {
    if (activePopup === id) {
      setActivePopup(null); // Popup schließen
    } else {
      setActivePopup(id); // Popup öffnen
    }
  };

  if (!selectedMarker) {
    return <div>Ort nicht gefunden!</div>; // Wenn kein Marker für den Ort gefunden wurde
  }

  return (
    <div className='wetter-container'>
       <div >
        <p style={{fontSize: '1.4rem'}}><strong>STANDORTINFORMATION: </strong><br></br>Seehöhe: {[selectedMarker.seehöhe]}, Geogr.Breite: {[selectedMarker.lat]},   Geogr.Länge: {[selectedMarker.lng]} </p>
      
      </div>
      <div >
        <Map 
        height={220} 
        defaultCenter={[selectedMarker.lat, selectedMarker.lng]} 
        defaultZoom={12} 
        minZoom={6}  
        maxZoom={18}
      >
        {/* Marker für den ausgewählten Ort */}
        <Marker 
          key={selectedMarker.id} 
          width={30} 
          anchor={[selectedMarker.lat, selectedMarker.lng]} 
          onClick={() => handleMarkerClick(selectedMarker.id)} // Marker klicken
        />

        {/* Popup für den aktiven Marker */}
        {activePopup && (
          <Overlay anchor={[selectedMarker.lat, selectedMarker.lng]} offset={[-50, 100]}>
            <div className='mymap-popup myortmap-popup' onMouseLeave={() => setActivePopup(null)}>
              <div className='marker-header'>
                <h3 style={{ color: '#ffffff' }}>{prettyStationName(ort)}</h3>
              </div>
              <ul>
                {selectedMarker.links.map((link, index) => (
                  <li key={index}>
                    <a href={link.url} rel="noopener noreferrer">{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          </Overlay>
        )}
      </Map>
      </div>
    </div>
  );
};

export default MyOrtMap;
